import type { SupplierClassificationStatus } from '../../types/supplier/supplier-classification-status.type';
import { EntityStatusModel } from '../entity-status.model';
import { EntityModel } from '../entity.model';

export class SupplierClassificationStatusModel implements SupplierClassificationStatus {
  readonly category: EntityModel | null;
  readonly status: EntityStatusModel | null;

  constructor(data: SupplierClassificationStatus) {
    this.category = data.category ? new EntityModel(data.category) : null;
    this.status = data.status ? new EntityStatusModel(data.status) : null;
  }
}
